import ProductReleaseCalendarEvent from 'components/molecules/calendar-event/product-release/ProductReleaseCalendarEvent';
import MagellanCalendar from 'components/organisms/calendar/MagellanCalendar';
import { TopbarPage } from 'components/templates';
import { addDays, endOfMonth, startOfMonth, subDays } from 'date-fns';
import { useState } from 'react';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { useTranslation } from 'react-i18next';
import { PiCalendar } from 'react-icons/pi';
import { useGetMusicProductReleases } from 'services/music-product-digital';
import { formatDateToInput } from 'utils/global/date.utils';

interface IRange {
  start: Date;
  end: Date;
}

const Calendar = () => {
  const { t } = useTranslation();
  const [releasesRange, setReleasesRange] = useState({
    start: subDays(startOfMonth(new Date()), 7),
    end: addDays(endOfMonth(new Date()), 7),
  });

  const releases = useGetMusicProductReleases({
    dateFrom: formatDateToInput(releasesRange.start, true),
    dateTo: formatDateToInput(releasesRange.end, true),
  });

  return (
    <TopbarPage
      topbar={
        // <TopBar
        //   title={`${t("navbar.home")} Calendar`}
        //   customBackItem={<div />}
        // />
        <div />
      }
    >
      <MagellanCalendar
        events={releases.data}
        date={addDays(releasesRange.start, 15)}
        startAccessor="releaseDate"
        endAccessor="releaseDate"
        topbarHeader={
          <>
            <PiCalendar /> {t('music-product-digital.premiere')}
          </>
        }
        components={{ event: ProductReleaseCalendarEvent }}
        titleAccessor={(event) => event.title.title}
        onRangeChange={(range) => setReleasesRange(range as IRange)}
      />
    </TopbarPage>
  );
};

export default Calendar;
